import RequestAbstract from "./RequestAbstract";

export default class Groups extends RequestAbstract {
    get link() {
        return this.links.groups;
    }
}
